import { Box } from '@chakra-ui/react';
import { Loader } from '@devd-client/devd/components';
import React from 'react';
import TeamView from './TeamTable';

interface CardTableProps {
  team: string;
  setTeamLength: any;
  appState?: any;
  teamLength?: number;
  plan?: string;
}

export const CardTable: React.FC<CardTableProps> = ({
  team,
  setTeamLength,
  appState,
  teamLength,
  plan,
}) => {
  return (
    <Box>
      <Box boxShadow={'lg'} borderRadius={'lg'}>
        <TeamView
          appState={appState}
          team={team}
          teamLength={teamLength}
          plan={plan}
          setTeamLength={setTeamLength}
        />
      </Box>
    </Box>
  );
};

export default CardTable;
